import { Box, Avatar, Typography, Chip } from "@mui/material";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import { phoneFormatInput } from "../../utils/Formatter";

export default function ContactLayout({ data, isPrimary }: any) {
  return (
    <Box sx={{ mt: isPrimary ? 0 : 2 }}>
      <Box display={"flex"} alignItems={"center"}>
        <Avatar
          alt={data?.name}
          src="/static/images/avatar/1.jpg"
          sx={{ width: 24, height: 24 }}
        />
        <Typography sx={{ marginLeft: 1 }} color="primary">
          {data?.name}
        </Typography>
        {isPrimary && (
          <Chip
            sx={{ marginLeft: 1 }}
            label="Primary"
            variant="outlined"
            color="primary"
          />
        )}
      </Box>
      <Box display={"flex"} alignItems={"center"} sx={{ mt: 0.5 }}>
        <PeopleOutlineOutlinedIcon
          style={{ color: "rgba(0, 0, 0, 0.54)", width: 24, height: 24 }}
        />
        <Typography sx={{ marginLeft: 1 }}>{data?.roles}</Typography>
      </Box>
      {data?.emails && data?.emails.length > 0 && (
        <Box display={"flex"} alignItems={"center"} sx={{ mt: 0.5 }}>
          <EmailOutlinedIcon
            style={{ color: "rgba(0, 0, 0, 0.54)", width: 24, height: 24 }}
          />
          <Typography sx={{ marginLeft: 1 }}>
            {data?.emails[0].emailAddress}
          </Typography>
        </Box>
      )}
      {data?.phones && data?.phones.length > 0 && (
        <Box display={"flex"} alignItems={"center"} sx={{ mt: 0.5 }}>
          <PhoneOutlinedIcon
            style={{ color: "rgba(0, 0, 0, 0.54)", width: 24, height: 24 }}
          />
          <Typography sx={{ marginLeft: 1 }}>
            {phoneFormatInput(data?.phones[0].phoneNumber)}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
